export const SET_PENDING = "state/battery-types/SET_PENDING";
export const SET_TOUCHED = "state/battery-types/SET_TOUCHED";
export const SET_BATTERY_TYPES = "state/battery-types/SET_BATTERY_TYPES";
export const FORGET_BATTERY_TYPES = "state/battery-types/FORGET_BATTERY_TYPES";
